import React from 'react'
import { WithTooltip } from '@/src/renderer/components/ui/tooltip'
import './TaskTagsBadge.scss'

export interface TaskTagsBadgeProps {
  /** Die Namen der Tags, in der gespeicherten Reihenfolge. Leer: nichts. */
  names: string[]
  /** Platz und Abstand am Einbauort. */
  className?: string
}

/**
 * **Die Tags einer Zeile als Anzeige** (#218) — eine Pille im Look der Tag-Pille an der Aufgabe,
 * aber ohne Knopf: Gesetzt wird über Menü und Details.
 *
 * Ab zwei Tags steht immer **eine** Pille „Garten +2“, alle Namen im Tooltip. Gemessen wird nicht:
 * Die Zeile einer Unteraufgabe ist eingerückt und schmal, eine Messung wie an der Aufgabe
 * (`useCollapsedRowFit`) brächte dort wenig.
 *
 * @example
 * <TaskTagsBadge names={['Garten']} />           // „Garten“
 * <TaskTagsBadge names={['Garten', 'Haus']} />   // „Garten +1“, Tooltip „Garten, Haus“
 */
export const TaskTagsBadge: React.FC<TaskTagsBadgeProps> = ({ names, className }) => {
  if (names.length === 0) return null
  const all = names.join(', ')
  const more = names.length - 1

  return (
    <WithTooltip content={more > 0 ? all : ''}>
      <span className={`task-tags-badge${className ? ` ${className}` : ''}`} role="img" aria-label={all}>
        <span className="task-tags-badge__name">{names[0]}</span>
        {more > 0 && <span className="task-tags-badge__more">{` +${more}`}</span>}
      </span>
    </WithTooltip>
  )
}
